export const paths = {
  any: '*',
  dashboard: '/dashboard',
  documents: {
    root: '/documents',
    askAi: '/documents/ask-ai',
    preview: '/documents/preview/:documentId',
    viewer: '/documents/document/:documentId',
    // Child routes (relative to /documents)
    children: {
      preview: 'preview/:documentId',
      document: 'document/:documentId',
    },
  },
  login: '/login',
  savings: '/savings',
  services: '/services',
  sites: '/sites',
  upcomingEvents: '/upcoming-events',
  chat: '/chat',
  yourTeam: '/your-team',
  account: '/account',
  billing: '/billing',
  vendors: '/vendors',
  about: '/about',
  reports: '/reports',
  subsidiaryOrganization: '/subsidiary-organization',
  tickets: '/tickets',
  help: '/help',
  billPay: '/bill-pay',
  contractTerms: '/contract-terms',
} as const;
